const MIN_REFRESH_INTERVAL = 30_000; // 30 seconds (AdSense policy)

interface SlotState {
  lastRefreshTime: number;
  pendingTimer: ReturnType<typeof setTimeout> | null;
}

class AdRefreshThrottler {
  private slots = new Map<string, SlotState>();

  requestRefresh(slotId: string, doRefresh: () => void): void {
    const now = Date.now();
    let state = this.slots.get(slotId);

    if (!state) {
      state = { lastRefreshTime: 0, pendingTimer: null };
      this.slots.set(slotId, state);
    }

    // Clear any pending timer (last-click-wins)
    if (state.pendingTimer !== null) {
      clearTimeout(state.pendingTimer);
      state.pendingTimer = null;
    }

    const elapsed = now - state.lastRefreshTime;

    if (elapsed >= MIN_REFRESH_INTERVAL) {
      state.lastRefreshTime = now;
      doRefresh();
    } else {
      const remaining = MIN_REFRESH_INTERVAL - elapsed;
      state.pendingTimer = setTimeout(() => {
        state!.lastRefreshTime = Date.now();
        state!.pendingTimer = null;
        doRefresh();
      }, remaining);
    }
  }

  recordInitialLoad(slotId: string): void {
    let state = this.slots.get(slotId);
    if (!state) {
      state = { lastRefreshTime: Date.now(), pendingTimer: null };
      this.slots.set(slotId, state);
    } else {
      state.lastRefreshTime = Date.now();
    }
  }

  clearSlot(slotId: string): void {
    const state = this.slots.get(slotId);
    if (state?.pendingTimer != null) {
      clearTimeout(state.pendingTimer);
    }
    this.slots.delete(slotId);
  }
}

export const adRefreshThrottler = new AdRefreshThrottler();
